import Highcharts from 'highcharts'

import { NODE_CONSTANTS } from './RoutingSankey.constants'

interface SankeyNode {
  id: string
  column: number
  color: string
}

export const SANKEY_NODES: SankeyNode[] = [
  {
    id: NODE_CONSTANTS.ROUTING_REQUESTS,
    color: 'var(--drift-dds-colors-purple8)',
    column: 0,
  },
  {
    id: NODE_CONSTANTS.TEAMMATES_ROUTED_IN,
    color: 'var(--drift-dds-colors-blue8)',
    column: 1,
  },
  {
    id: NODE_CONSTANTS.TEAMMATES_NOT_ROUTED_IN,
    column: 1,
    color: 'var(--drift-dds-colors-blue8)',
  },
  {
    id: NODE_CONSTANTS.MISSED,
    column: 2,
    color: 'var(--drift-dds-colors-orange6)',
  },
  {
    id: NODE_CONSTANTS.TEAMMATES_UNAVAILABLE,
    column: 2,
    color: 'var(--drift-dds-colors-teal5)',
  },
  {
    id: NODE_CONSTANTS.RESPONDED_WITHIN_60S,
    column: 2,
    color: 'var(--drift-dds-colors-green6)',
  },
  {
    id: NODE_CONSTANTS.RESPONSE_LATE,
    column: 3,
    color: 'var(--drift-dds-colors-yellow6)',
  },
  {
    id: NODE_CONSTANTS.NO_RESPONSE,
    column: 3,
    color: 'var(--drift-dds-colors-red8)',
  },
  {
    id: NODE_CONSTANTS.TEAMMATE_RESPONDED,
    column: 4,
    color: 'var(--drift-dds-colors-green6)',
  },
  {
    id: NODE_CONSTANTS.AWAY_MESSAGE_SENT,
    column: 4,
    color: 'var(--drift-dds-colors-blue8)',
  },
  {
    id: NODE_CONSTANTS.CALENDAR_DROP,
    column: 4,
    color: 'var(--drift-dds-colors-blue8)',
  },
  {
    id: NODE_CONSTANTS.CREATE_TICKET,
    column: 4,
    color: 'var(--drift-dds-colors-blue8)',
  },
  {
    id: NODE_CONSTANTS.DEAD_END,
    column: 4,
    color: 'var(--drift-dds-colors-red8)',
  },
]

export const SANKEY_OPTIONS: Highcharts.Options = {
  title: {
    text: '',
  },
  chart: {
    style: {
      fontFamily: 'var(--main-font-family)',
    },
    height: 360,
  },
  plotOptions: {
    sankey: {
      minLinkWidth: 8,
      nodeWidth: 8,
    },
  },
}
